import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { expedienteService } from '../services/expedienteService';

/** Fotos ya guardadas de esos estudiantes; llena el diálogo al abrirse. */
export function useExpedientesGuardados(ruts: number[], enabled = true) {
  const clave = [...ruts].sort((a, b) => a - b);
  return useQuery({
    queryKey: ['expedientes', clave],
    queryFn: () => expedienteService.guardados(clave),
    enabled: enabled && clave.length > 0,
    // Consultar UCampus es caro: lo guardado no se refresca solo al volver a la pestaña.
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useGuardarExpedientes() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: expedienteService.guardar,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['expedientes'] }),
  });
}
